import { all, takeEvery, call, put } from "redux-saga/effects";
import * as actionTypes from "../constants/actionTypes";
import * as actions from '../actions'
import axios from '../services';
import { sessionExpiredMsg } from "../constants/constants";

function* getHomeData(action) {
    try {
        let responseUser, deselectedList;
        if(action.payload.filterFlag == false) {
            responseUser = yield axios
                .get("/users")
                .then(async response => response)
                .catch(async error => {
                    return error;
                });
            
            let list = [];
            if(responseUser.data.data.userContestFilter == 'global') {
                
                let responseFilter = yield axios.get(`/contests/filter-contest-list`)
                    .then(async response => response)
                    .catch(async error => {
                        return error;
                    });
                if(responseFilter.status == 200) {
                    responseFilter.data.data.map(category => {
                        let contest = category.contest.map(item => {
                            if(category._id != 'GLOBAL' && category._id != responseUser.data.data.locationInfo.country) {
                                list.push(item.name);
                            }
                        });
                    })
                }
                deselectedList = list.join(',');
            } else {
                deselectedList = responseUser.data.data.userContestFilter;
            }
        } else {
            deselectedList = action.payload.deselectedList;
        }

        let responseList = [];
        let category = yield axios.get('/category')
            .then(async response => response)
            .catch(async error => {
                return error;
            });
        
        let categoryCountryList = yield axios.get('/contests/contest-country-list')
            .then(async response => response)
            .catch(async error => {
                return error;
            });

        let featuredVideo = yield axios.get('/users/feature-video')
            .then(async response => response)
            .catch(async error => {
                return error;
            });

        let allContest = yield axios.get(`/country/countryWise-contests/all?contest=${deselectedList}`)
            .then(async response => response)
            .catch(async error => {
                return error;
            });

        let countryWiseContest = yield axios.get(`/country/all-contest-countryWise?contest=${deselectedList}`)
            .then(async response => response)
            .catch(async error => {
                return error;
            });

        let dailyContestWinner = yield axios.post('/contests/all-contest-daily-winner1', {
            skip: 0,
            limit: 6,
            contestFilter: action.payload.filterFlag == false ? responseUser.data.data.userContestFilter == 'global' ? list.join(',') : responseUser.data.data.userContestFilter : action.payload.deselectedList,
        })
            .then(async response => response)
            .catch(async error => {
                return error;
            });
        responseList.push(category);
        responseList.push(featuredVideo);
        responseList.push(allContest);
        responseList.push(countryWiseContest);
        responseList.push(dailyContestWinner);
        responseList.push(categoryCountryList);

        let result = yield Promise.all(responseList);

        if (category == "Error: Request failed with status code 401") {
            yield put(actions.hideAppLoader());
            put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
        }
        else if (category.status !== 200) {
            yield put(actions.hideAppLoader());
            yield put(actions.homeerror());
            yield put(actions.modalOpen({ message: category.message }));
        } 

        if (featuredVideo == "Error: Request failed with status code 401") {
            yield put(actions.hideAppLoader());
            put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
        }
        else if (featuredVideo.status !== 200) {
            yield put(actions.hideAppLoader());
            yield put(actions.homeerror());
            yield put(actions.modalOpen({ message: featuredVideo.message }));
        } 

        if (allContest == "Error: Request failed with status code 401") {
            yield put(actions.hideAppLoader());
            put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
        }
        else if (allContest.status !== 200) {
            yield put(actions.hideAppLoader());
            yield put(actions.homeerror());
            yield put(actions.modalOpen({ message: allContest.message }));
        }

        if (countryWiseContest == "Error: Request failed with status code 401") {
            yield put(actions.hideAppLoader());
            put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
        }
        else if (countryWiseContest.status !== 200) {
            yield put(actions.hideAppLoader());
            yield put(actions.homeerror());
            yield put(actions.modalOpen({ message: countryWiseContest.message }));
        }
        
        if (categoryCountryList == "Error: Request failed with status code 401") {
            yield put(actions.hideAppLoader());
            put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
        }
        else if (categoryCountryList.status !== 200) {
            yield put(actions.hideAppLoader());
            yield put(actions.homeerror());
            yield put(actions.modalOpen({ message: categoryCountryList.message }));
        }

        if (dailyContestWinner == "Error: Request failed with status code 401") {
            yield put(actions.hideAppLoader());
            put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
        } else if (dailyContestWinner.status !== 200) {
            yield put(actions.hideAppLoader());
            yield put(actions.homeerror());
            yield put(actions.modalOpen({ message: response.message }));
        }

        if (category.status == 200) {
            yield put(actions.getHomeDataSuccess({
                category: result[0].data.data,
                featuredVideo: result[1].data.data,
                allContest: result[2].data.data,
                countryWiseContest: result[3].data.data.filter(data => data._id != null),
                dailyContestWinner: result[4].data.data,
                categoryCountryList: result[5].data.data,
            }));
        }
    } catch (error) {
        console.log("ERROR FROM SAGA HOME", error.message);
    }
}

function* getContest(action) {
    try {
        let response = yield axios.get('/category')
            .then(async response => response)
            .catch(async error => {
                return error;
            });
        if (response.status == 200) {
            yield put(actions.getContestHomeDataSuccess({
                category: response.data.data,
            }));
        }
        else if (response == "Error: Request failed with status code 401") {
            yield put(actions.hideAppLoader());
            yield put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
        } else if (response) {
            yield put(actions.hideAppLoader());
            yield put(actions.homeerror())
            yield put(actions.modalOpen({ message: response.message }));
        } else {
            yield put(actions.hideAppLoader());
            yield put(actions.modalOpen({ message: response.response.data.msg }));
        }
    } catch (error) {
        console.log("ERROR FROM SAGA HOME", error.message);
    }
}

function* getFeaturedVideo(action) {
    try {
        let response = yield axios.get(`/users/feature-video?skip=${action.payload}&limit=5`)
            .then(async response => response)
            .catch(async error => {
                return error;
            });
        if (response.status == 200) {
            yield put(actions.getFeaturedVideoSuccess({
                featuredVideo: response.data.data,
                newData: action.payload == 0
            }));
        }
        else if (response == "Error: Request failed with status code 401") {
            yield put(actions.hideAppLoader());
            put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
        } else if (response) {
            yield put(actions.hideAppLoader());
            yield put(actions.homeerror())
            yield put(actions.modalOpen({ message: response.message }));
        } else {
            yield put(actions.hideAppLoader());
            yield put(actions.modalOpen({ message: response.response.data.msg }));
        }

    }
    catch (error) {
        console.log("ERROR FROM SAGA FEATURED VIDEO", error.message);
    }
}

function* getContestData() {
    try {
        let response = yield axios.get('/country/countryWise-contests/all')
            .then(async response => response)
            .catch(async error => {
                return error;
            });
        if (response.status == 200) {
            yield put(actions.getContestDataSuccess({
                allContest: response.data.data,
            }));
        }
        else if (response == "Error: Request failed with status code 401") {
            yield put(actions.hideAppLoader());
            yield put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
        } else if (response) {
            yield put(actions.hideAppLoader());
            yield put(actions.homeerror())
            yield put(actions.modalOpen({ message: response.message }));
        } else {
            yield put(actions.hideAppLoader());
            yield put(actions.modalOpen({ message: response.response.data.msg }));
        }

    } catch (error) {
        //console.log("ERROR FROM SAGA FEATURED VIDEO", error.message);

    }
}

function* getCountryWiseContestData({ payload }) {
    try {
        let response;
        if (payload == "all") {
            response = yield axios.get(`/country/all-contest-countryWise`)
                .then(async response => response)
                .catch(async error => {
                    return error;
                });

        } else {
            response = yield axios.get(`/country/all-contest-countryWise?category=${payload}`)
                .then(async response => response)
                .catch(async error => {
                    return error;
                });
        }
        if (response.status == 200) {
            yield put(actions.getCountryWiseContestDataSuccess({
                countryWiseContest: response.data.data.filter(data => data._id != null),
            }));
        }
        else if (response == "Error: Request failed with status code 401") {
            yield put(actions.hideAppLoader());
            put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
        } else if (response) {
            yield put(actions.hideAppLoader());
            yield put(actions.homeerror())
            yield put(actions.modalOpen({ message: response.message }));
        } else {
            yield put(actions.hideAppLoader());
            yield put(actions.modalOpen({ message: response.response.data.msg }));
        }

    } catch (error) {
        console.log("ERROR FROM SAGA FEATURED VIDEO", error.message);
    }
}

function* getMonthlyActiveVoters(action) {
    try {
        let response = yield axios.post(`/users/monthly-active-voters?limit=3`)
            .then(async response => response)
            .catch(async error => {
                return error;
            });

        if (response.status == 200) {
            yield put(actions.getMonthlyActiveVotersSuccess(response.data.data));
        } else if (response == "Error: Request failed with status code 401") {
            yield put(actions.hideAppLoader());
            put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
        } else if (response) {
            yield put(actions.hideAppLoader());
            yield put(actions.homeerror())
            yield put(actions.modalOpen({ message: response.message }));
        } else {
            yield put(actions.hideAppLoader());
            yield put(actions.modalOpen({ message: response.response.data.msg }));
        }
    } catch (error) {
        //console.log("Error From Saga Contests", error);

    }
}

function* getMyActivity(action) {
    try {
        let response = yield axios.get(`/votes/my-activity?weekIndex=${action.payload}`)
            .then(async response => response)
            .catch(async error => {
                return error;
            });

        if (response.status == 200) {
            yield put(actions.getMyActivitySuccess({
                myActivity: {
                    ...response.data.data,
                    ChartData: {
                        datasets: [{
                            data: Array.from(response.data.data.chartData, item => item.countOfMinutes),
                            backgroundColor: "#b3d9fe"
                        }],
                        labels: Array.from(response.data.data.chartData, item => item.weekDayName),
                    },
                },
                myActivityIndex: action.payload,
            }));
        } else if (response == "Error: Request failed with status code 401") {
            yield put(actions.hideAppLoader());
            put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
        } else if (response) {
            yield put(actions.hideAppLoader());
            yield put(actions.homeerror())
            yield put(actions.modalOpen({ message: response.message }));
        } else {
            yield put(actions.hideAppLoader());
            yield put(actions.modalOpen({ message: response.response.data.msg }));
        }
    } catch (error) {
        //console.log("Error From Saga Contests", error);

    }
}

export default function* rootsaga() {
    yield takeEvery(actionTypes.GET_CONTEST_HOME_PAGE_DATA, getContest);
    yield takeEvery(actionTypes.GET_FEATURE_VIDEO, getFeaturedVideo);
    yield takeEvery(actionTypes.GET_CONTEST_DATA, getContestData)
    yield takeEvery(actionTypes.GET_COUNTRY_WISE_CONTEST_DATA, getCountryWiseContestData)
    yield takeEvery(actionTypes.GET_HOME_DATA, getHomeData)
    yield takeEvery(actionTypes.GET_MY_ACTIVITY, getMyActivity)
    yield takeEvery(actionTypes.GET_MONTHLY_ACTIVE_VOTERS, getMonthlyActiveVoters)
}